import "./VolunteerSignUp.module.css";
import SiteHeader from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import WhyVolunteer from "./sections/WhyVolunteer";
import LawnTreatmentMaintenance from "./sections/LawnTreatmentMaintenance";
import StSampsonFooter from "@/reusable_sections/Footer";
export default function VolunteerSignUpPage() {
  return <div>
      <SiteHeader />
      <Hero />
      <WhyVolunteer />
      <LawnTreatmentMaintenance />
      <StSampsonFooter />
    </div>;
}